import { Component, Input } from '@angular/core';

@Component({
  selector: 'std-loader',
  template: `
    <div 
      class="fixed top-0 z-[10000] left-0  !w-screen !h-[100dvh] bg-black !bg-opacity-25 flex items-center justify-center"
    >
      <div
        [class]="
          'h-32 w-32 animate-spin border-[6px] border-t-[var(--primary)]  rounded-full ' +
          customClass
        "
      >
        <img *ngIf="img" class="h-32 w-32" [src]="img" [class]="imgClass" />
      </div>
    </div>
  `,
  styles: [],
  standalone: false,
})
export class LoaderComponent {
  constructor() {}
  @Input() img!: string;
  @Input() imgClass = '';
  @Input() customClass: string = '';
}
